import Block, { BlockContent } from "~/components/Block";

// TODO: Extends getCommonSliceProps
type QuestionGridProps = {
  spacingTop?: number;
  spacingBottom?: number;
  backgroundColor?: string;
  highlightColor?: string;
  color?: string;
  animateIn?: boolean;
};

export default function QuestionGrid(props: QuestionGridProps) {
  const {
    spacingTop = 0,
    spacingBottom = 6,
    highlightColor,
    color,
    backgroundColor,
    animateIn = false,
  } = props;

  return null;
  return (
    <Block
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
      backgroundColor={backgroundColor}
      color={color}
    >
      <BlockContent>
        <p>TODO</p>
      </BlockContent>
    </Block>
  );
}
